import { ref, watch, type Ref } from "vue";

export interface PersistentToggle {
  value: Ref<boolean>;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export function usePersistentToggle(key: string, defaultValue = false): PersistentToggle {
  const read = (): boolean => {
    if (typeof window === "undefined") return defaultValue;
    const raw = window.localStorage.getItem(key);
    if (raw === null) return defaultValue;
    return raw === "1";
  };

  const value = ref<boolean>(read());

  watch(value, (v) => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(key, v ? "1" : "0");
  });

  return {
    value,
    toggle: () => {
      value.value = !value.value;
    },
    open: () => {
      value.value = true;
    },
    close: () => {
      value.value = false;
    },
  };
}
